module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="apexchat_scripts_none_main_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n    class="apexchat_message livechat_message_wrapper apexchat_question_type_custom_style_div ';
 if(userId == -1){ ;
__p += ' apexchat_system';
};

 if(userId == 0){ ;
__p += ' apexchat_visitor';
};

 if(userId > 0 || userId == -3){ ;
__p += ' apexchat_agent';
};
__p += ' apexchat_script_message_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n    <div class="apexchat_question_type_single_col radio">\r\n        <div class="apexchat_speaker apexchat_speaker_wrapper">\r\n            <!-- <div class="qt-user apexchat_speaker apexchat_participant_display_text"\r\n                id="apexchat_participant_display_name">\r\n                ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
'\r\n            </div>\r\n            <div class="apexchat_speaker apexchat_participant_display_text" id="apexchat_participant_display_col">:&nbsp\r\n            </div> -->\r\n            <div class="apexchat_text apexchat_participant_display_text livechat_rd_fade_in_bottom" tabindex="0"\r\n                id="apexchat_participant_display_text">\r\n                <span>\r\n                    ' +
((__t = (text )) == null ? '' : __t) +
'\r\n                </span>\r\n                <div id="apexchat_question_type_multiple_choice_file_div_' +
((__t = (id)) == null ? '' : __t) +
'" class="livechat_files_container">\r\n                </div>\r\n            </div>\r\n            <!-- ' +
((__t = (participantDisplayName )) == null ? '' : __t) +
': ' +
((__t = (text )) == null ? '' : __t) +
' -->\r\n            <span aria-hidden="true"\r\n                class="apexchat_rd_timer_span livechat_rd_fade_in_bottom apexchat_rd_question_type_timer">\r\n                <!--For Visitor-->\r\n                ' +
((__t = (ApexChat.getCurrentFormatedDateTime(createdOn, 'hh:mmTT' ) )) == null ? '' : __t) +
'\r\n            </span>\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}